export default __webpack_public_path__ + "images/assets/f0fcb930b3ca5b04141db823995c5c92.svg";